import { render, staticRenderFns } from "./CustomSzwtProcessForm.vue?vue&type=template&id=d283e1be&scoped=true&"
import script from "./CustomSzwtProcessForm.vue?vue&type=script&lang=js&"
export * from "./CustomSzwtProcessForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d283e1be",
  null
  
)

export default component.exports